export default __webpack_public_path__ + "static/media/download-balance.c37c0ffc.svg";